// https://element-plus.org/zh-CN/
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// rem换算
import "../../assets/main.css";
import { initSetRootFontSize } from "@/util/rem2";
initSetRootFontSize();
import "animate.css";

// 日期和时间本地化
// import "dayjs/locale/zh-cn";
import i18n from "./i18n";

// https://animate.style/
// import 'animate.css';

// import '../../assets/main.css'

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueDOMPurifyHTML from "vue-dompurify-html";

import * as Sentry from "@sentry/vue";

import { store } from "./store";

import RaEventTrackerPlugin from "./tracker"; // 引入你创建的星辉统计插件

// faecbook插件SDK库
// import { loadSdk } from "@/util/loadSdk";
// import i18n from "./i18n";
// loadSdk("fb", "zh_TW");

const app = createApp(App);

// 调试器
if (import.meta.env.DEV) {
  import("vconsole").then(({ default: VConsole }) => {
    new VConsole();
  });
}

// cookies的使用
import { xhSet, xhGet } from "@/util/xhCookie";
import { lang } from "@/util/base";
// 全部变量都存储这里
const existingCookies = xhGet("XH-WEB");

// 如果 cookies.get("XH-WEB") 返回 undefined，则设置一个默认的初始值
const initialCookies = {
  ...xhGet("XH-WEB"),
  // 初始化页面语言
  page_lang: existingCookies?.page_lang || lang(),
  fb_lang: existingCookies?.fb_lang || lang(),
};
xhSet("XH-WEB", initialCookies);

import { loadSdk } from "@/util/loadSdk";
if (xhGet("XH-WEB")?.fb_lang) {
  loadSdk("fb", xhGet("XH-WEB").fb_lang);
}

import { Fingerprint } from "xhwebtool";
// 不存在设备指纹时，写入作为设备ID，写入后除非用户手动删除，否则不改变
if (!localStorage.getItem("fingerprint")) {
  Fingerprint.fingerprint().then((res) => {
    localStorage.setItem("fingerprint", res);
  });
}

Sentry.init({
  app,
  dsn: "https://51a676e58f740faa892d735ef27a1cde@o577525.ingest.us.sentry.io/4507674516783104",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(VueDOMPurifyHTML);
app.use(RaEventTrackerPlugin); // 使用星辉统计插件
app.mount("#app");
